import { createSlice } from "@reduxjs/toolkit";

const scheduleInitState = {
  isLoading: false,
  schedules: [],
  schedule: {},
  gymSchedule: [],
  progress: {},
  isPlaying: {},
  remainingDuration: {},
};
const scheduleReducerSlice = createSlice({
  name: "schedule",
  initialState: scheduleInitState,
  reducers: {
    changeScheduleLoading: (state, action) => {
      if (state.isLoading !== action.payload) {
        state.isLoading = action.payload;
      }
    },
    addScheduleState: (state, action) => {
      state.schedules.unshift(action.payload);
      state.isLoading = false;
    },
    setDuplicateSchedules: (state, action) => {
      // state.schedules.unshift(action.payload);
      state.schedules = [...action.payload, ...state.schedules];

      state.isLoading = false;
    },
    setScheduleById: (state, action) => {
      state.schedule = action.payload;
      state.isLoading = false;
    },
    setScheduleState: (state, action) => {
      if (state.schedules.length <= 0 || action.payload.refresh) {
        state.schedules = action.payload.schedules || state.schedules;
      }
      state.isLoading = false;
    },
    setGymScheduleState: (state, action) => {
      if (state.gymSchedule.length <= 0 || action.payload.refresh) {
        state.gymSchedule = action.payload.gymSchedule || state.gymSchedule;
      }
      state.isLoading = false;
    },
    editScheduleState: (state, action) => {
      state.schedules = state.schedules.map((schedule) => {
        if (action.payload._id === schedule._id) {
          schedule = action.payload;
        }
        return schedule;
      });
      state.isLoading = false;
    },
    deleteScheduleState: (state, action) => {
      state.schedules = state.schedules.filter(
        (schedule) => schedule._id !== action.payload
      );
      state.isLoading = false;
    },
    updateProgressState: (state, action) => {
      const { sessionId, progress } = action.payload;
      state.progress[sessionId] = progress;
    },
    updateIsPlayingState: (state, action) => {
      const { sessionId, isPlaying } = action.payload;
      state.isPlaying[sessionId] = isPlaying;
    },
    updateRemainingDurationState: (state, action) => {
      const { sessionId, remainingDuration } = action.payload;
      state.remainingDuration[sessionId] = remainingDuration;
    },
    
  },
});

export const {
  changeScheduleLoading,
  addScheduleState,
  setScheduleState,
  setScheduleById,
  deleteScheduleState,
  editScheduleState,
  setDuplicateSchedules,
  setGymScheduleState,
  setProgressState, updateProgressState,
  updateIsPlayingState,
  updateRemainingDurationState,
} = scheduleReducerSlice.actions;

export default scheduleReducerSlice.reducer;
